var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "row no-gutters" }, [
      _c("div", { staticClass: "col-12" }, [
        _c("h2", { staticClass: "order-summary__head" }, [
          _vm._v(
            "\n                " +
              _vm._s(
                _vm.getTranslation("order-content", _vm.translate, {
                  name: _vm.product.name,
                })
              ) +
              "\n            "
          ),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "custom-table" }, [
      _c("div", { staticClass: "row custom-table__head d-none d-sm-flex" }, [
        _c("div", { staticClass: "col-6" }, [
          _c("div", { staticClass: "custom-table__head--elem" }, [
            _vm._v(_vm._s(_vm.getTranslation("product-list-vue", "program"))),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-2" }, [
          _c("div", { staticClass: "custom-table__head--elem text-sm-right" }, [
            _vm._v(_vm._s(_vm.getTranslation("front", "quantity"))),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-2" }, [
          _c("div", { staticClass: "custom-table__head--elem text-sm-right" }, [
            _vm._v(_vm._s(_vm.getTranslation("front", "price"))),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-2" }, [
          _c("div", { staticClass: "custom-table__head--elem text-sm-right" }, [
            _vm._v(_vm._s(_vm.getTranslation("front", "total"))),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "row no-gutters custom-table__body" },
        [
          _vm._l(_vm.sortedPrograms(), function (program) {
            return program.product == _vm.product.id &&
              program[_vm.licenceType] > 0
              ? [
                  _c(
                    "div",
                    { staticClass: "col-4 custom-table__title d-sm-none" },
                    [
                      _c("div", { staticClass: "custom-table__title--elem" }, [
                        _vm._v(
                          _vm._s(
                            _vm.getTranslation("product-list-vue", "program")
                          )
                        ),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-8 col-sm-6" }, [
                    _c("div", {
                      staticClass: "custom-table__body--elem",
                      domProps: { innerHTML: _vm._s(_vm.programName(program)) },
                    }),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-4 custom-table__title d-sm-none" },
                    [
                      _c("div", { staticClass: "custom-table__title--elem" }, [
                        _vm._v(_vm._s(_vm.getTranslation("front", "quantity"))),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-8 col-sm-2 text-sm-right" }, [
                    _c("div", { staticClass: "custom-table__body--elem" }, [
                      _vm._v(_vm._s(_vm.quantity(program))),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-4 custom-table__title d-sm-none" },
                    [
                      _c("div", { staticClass: "custom-table__title--elem" }, [
                        _vm._v(_vm._s(_vm.getTranslation("front", "price"))),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-8 col-sm-2 text-sm-right" }, [
                    _c("div", { staticClass: "custom-table__body--elem" }, [
                      _vm._v(_vm._s(_vm.linePrice(program))),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-4 custom-table__title d-sm-none" },
                    [
                      _c("div", { staticClass: "custom-table__title--elem" }, [
                        _vm._v(_vm._s(_vm.getTranslation("front", "total"))),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-8 col-sm-2 text-sm-right" }, [
                    _c("div", { staticClass: "custom-table__body--elem" }, [
                      _vm._v(_vm._s(_vm.totalPrice(program))),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "col-12 d-sm-none custom-table__separator",
                  }),
                ]
              : _vm._e()
          }),
        ],
        2
      ),
    ]),
    _vm._v(" "),
    _c("br"),
    _c("br"),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }